import { Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpRequest } from "@angular/common/http";
import { Observable } from 'rxjs';
import { LockType } from '../models/lockType';
import { TestLock } from '../models/testLock';
import { AppConfig } from '../config/app-config';
import { ReqGenerateCryptoKeys } from '../models/reqGenerateCryptoKeys';
import { ReqExportCryptoKeys } from '../models/reqExportCryptoKeys';

@Injectable({
  providedIn: 'root'
})
export class CountriesDataService {
  constructor(private http: HttpClient, private appConfig: AppConfig) { }
 
  headers = new HttpHeaders();

    getCountriesList(): Observable<any[]> {
    return this.http.get<any[]>(this.appConfig.urlKeysApi + 'Country/GetCountriesList');
  }

  generateCryptoKeys(req: ReqGenerateCryptoKeys) {

    return this.http.post(this.appConfig.urlKeysApi + 'Country/GenerateCryptoKeys', req)
  }

  uploadCryptoKeys(formData, user: string): Observable<HttpEvent<any>> {
    let params = new HttpParams()
      .set("user", user)
    
    const uploadReq = new HttpRequest('POST', this.appConfig.urlKeysApi+ "Country/UploadCryptoKeys", formData, { headers: this.headers, params: params });
    return this.http.request(uploadReq);
  }

  getTestLocks(conutryId: number) {
    let params = new HttpParams()
      .set("conutryId", conutryId !== null ? conutryId.toString() : '');

    return this.http.get<any>(this.appConfig.urlKeysApi + 'Country/GetTestLocks', { headers: this.headers, params: params })

    //return this.http.post(this.baseUrl + 'Country/GetTestLocks', conutryId)
  }


  getLockTypes(): Observable<LockType[]> {
    return this.http.get<any>(this.appConfig.urlKeysApi + "Country/GetLockTypes");
  }

  saveLock(lock: TestLock) {
    return this.http.post(this.appConfig.urlKeysApi + 'Country/SaveLock', lock);
  }

  deleteLock(lock: TestLock) {
    return this.http.post(this.appConfig.urlKeysApi + 'Country/DeleteLock', lock);
  }

  recoverLock(lock: TestLock) {
    return this.http.post(this.appConfig.urlKeysApi + 'Country/RecoverLock', lock);
  }

  exportCryptoKeys(req: ReqExportCryptoKeys): Observable<Blob> {
    return this.http.post<Blob>(this.appConfig.urlKeysApi + 'Country/ExportCryptoKeys', req, { responseType: 'blob' as 'json' });
  }



}
